import { ArrowUpRight } from "lucide-react";
import { AMAZON_AUTHOR_URL, ISBN } from "@/constants/site";

export const Footer = () => (
  <footer data-testid="site-footer" className="relative border-t border-white/10 bg-[#050505]">
    <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-14 flex flex-col gap-10">
      <div className="flex flex-col md:flex-row md:items-end justify-between gap-8">
        <div>
          <p className="font-display italic font-light text-3xl text-white">The Aurora Chronicles</p>
          <p className="font-tech text-[10px] uppercase tracking-[0.3em] text-zinc-500 mt-3">
            Northern Lights Rising · Book One of Two
          </p>
        </div>
        <a
          href={AMAZON_AUTHOR_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="footer-amazon-author"
          className="group inline-flex items-center gap-2 font-tech text-[11px] uppercase tracking-[0.25em] text-zinc-400 hover:text-emerald-300 transition-colors duration-300"
        >
          Follow Michael B. Ford on Amazon
          <ArrowUpRight size={14} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
        </a>
      </div>
      <div className="flex flex-col md:flex-row justify-between gap-4 border-t border-white/10 pt-8 font-tech text-[10px] uppercase tracking-[0.25em] text-zinc-600">
        <span>© 2025 Michael B. Ford</span>
        <span>ISBN {ISBN}</span>
        <span>Independently published</span>
      </div>
    </div>
  </footer>
);

export default Footer;
